import { View } from '@react-pdf/renderer';
import { divideDataBetweenTables } from 'PDF/helpers/pdfMapping';

import { IStripedTableProps, IStripedTableRow, StripedTable } from './StripedTable';
import { SmallHeading } from '../SmallHeading';

export const StripedTableWrapper = ({ rows, heading, fixedRows }: IStripedTableProps & { heading?: string }) => {
  const filteredRows = rows.filter(
    ({ info }) => info.filter((item) => (typeof item === 'object' ? item?.value : item)).length,
  );

  if (!filteredRows.length) {
    return null;
  }

  const arraysOfRows: IStripedTableRow[][] =
    filteredRows[0].info.length > 3 ? divideDataBetweenTables(filteredRows, 'info') : [filteredRows];

  return (
    <>
      {arraysOfRows.map((rows, index) => (
        <>
          {heading && !index && <SmallHeading heading={heading} minPresenceAhead={200} />}
          <View minPresenceAhead={!index ? 0 : 250}></View>
          <View key={index} style={{ marginBottom: 30 }}>
            <StripedTable rows={rows} fixedRows={fixedRows} />
          </View>
        </>
      ))}
    </>
  );
};
